"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = setIndex;
var i = 0;

function setIndex() {
  i += 1;
  return i;
}
//# sourceMappingURL=indexService.js.map